import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sadeteenshaktipeethtourfrom() {



  const cardData =
  {
    keyword: 'Sade Teen Shakti Peeth Tour From Pune by bus Package',
    heading: 'Sanavi Travels: Sade Teen Shakti Peeth Tour From Pune by bus Package',
    headingDescription: 'Sanavi Travels offers reliable Sade Teen Shakti Peeth Tour from Pune by Bus Package, providing safe, comfortable, and well-organized transportation for pilgrims, families, and religious groups planning a spiritual journey from Pune to the revered Sade Teen Shakti Peeth temples. Our fleet of AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, is well-maintained with spacious seating, ample legroom, and sufficient luggage space to ensure a smooth and serene pilgrimage journey. With experienced drivers familiar with pilgrimage routes, flexible one-day and multi-day tour packages, transparent pricing, and punctual service, Sanavi Travels ensures a safe and fulfilling spiritual experience. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering all three Sade Teen Shakti Peeth temples on the itinerary. Choose Sanavi Travels to book Sade Teen Shakti Peeth tour from Pune by bus, ensuring devotion, comfort, safety, and a memorable spiritual journey.',

    top: 'Top Places to Visit in Sade Teen Shakti Peeth with Sanavi Travels',


"topPlaces": [
  {
    "title": "Kali Shakti Peeth – Shree Kalighat Temple",
    "description": "Kalighat Temple in Kolkata is one of the most revered Shakti Peeths, dedicated to Goddess Kali. It is believed that a part of Sati’s toe fell here. The temple is famous for its vibrant rituals, devotional music, and spiritual energy. Pilgrims visit year-round to offer prayers and seek blessings. Kalighat represents deep devotion and the divine feminine power."
  },
  {
    "title": "Kamakhya Shakti Peeth – Kamakhya Temple",
    "description": "Kamakhya Temple, located in Guwahati, Assam, is a significant Shakti Peeth associated with Goddess Kamakhya. Believed to house a part of Sati’s womb, the temple is a major pilgrimage site, especially during the Ambubachi Mela. The temple’s unique tantric traditions and scenic location atop Nilachal Hill make it spiritually and culturally significant."
  },
  {
    "title": "Vaishno Devi Shakti Peeth – Vaishno Devi Temple",
    "description": "Vaishno Devi Temple in Katra, Jammu & Kashmir, is one of India’s most visited Shakti Peeths, dedicated to Goddess Vaishno Devi. Pilgrims trek through scenic hills to reach the cave shrine, believed to be where Sati’s heart fell. The temple is renowned for its spiritual energy, devotion, and breathtaking natural surroundings. Vaishno Devi symbolizes faith, perseverance, and divine protection."
  }
]
,




"services": [
  {
    "name": "Sade Teen Shakti Peeth Tour From Pune by Bus Package",
    "description": "Sade Teen Shakti Peeth Tour From Pune by Bus Package offers comfortable and reliable buses for pilgrims traveling from Pune to the three revered Shakti Peeth temples. The buses are spacious, well-maintained, and equipped with professional drivers to ensure safety and timely travel. This package is ideal for families, friends, or group tours seeking a convenient and organized pilgrimage experience, with flexible booking options and affordable pricing."
  },
  {
    "name": "Shakti Peeth Yatra Bus Pune",
    "description": "Shakti Peeth Yatra Bus Pune provides dedicated buses for visiting the Shakti Peeth temples, combining comfort, safety, and reliability. These buses are perfect for families, friends, or organized groups undertaking the spiritual yatra, offering ample seating, luggage space, and professional chauffeurs to handle long-distance travel efficiently."
  },
  {
    "name": "AC Bus Shakti Peeth Tour",
    "description": "AC Bus Shakti Peeth Tour offers air-conditioned travel for pilgrims from Pune to the Shakti Peeth temples, ensuring a cool and comfortable journey. Spacious seating, ample luggage space, and professional drivers make it ideal for long-distance travel, group tours, and family trips, providing a stress-free and pleasant travel experience."
  },
  {
    "name": "Luxury Bus Shakti Peeth Yatra",
    "description": "Luxury Bus Shakti Peeth Yatra provides premium vehicles for a comfortable and elegant pilgrimage experience. Equipped with reclining seats, entertainment features, and ample luggage space, these buses are suitable for VIP groups, families, or corporate travelers seeking convenience and style while visiting the Shakti Peeth temples."
  },
  {
    "name": "Family Shakti Peeth Bus Pune",
    "description": "Family Shakti Peeth Bus Pune ensures safe and comfortable travel for families visiting the Shakti Peeth temples. Spacious seating, luggage-friendly interiors, and child-friendly features make the journey stress-free, allowing families to focus on the spiritual experience while drivers handle all travel logistics."
  },
  {
    "name": "Group Travel Shakti Peeth Bus",
    "description": "Group Travel Shakti Peeth Bus caters to large groups undertaking the Shakti Peeth pilgrimage from Pune. With well-maintained buses, professional drivers, and organized travel schedules, this service ensures a smooth, safe, and convenient journey for tourists, devotees, and corporate groups traveling together."
  },
  {
    "name": "Affordable Shakti Peeth Bus Package",
    "description": "Affordable Shakti Peeth Bus Package offers budget-friendly travel options without compromising on safety or comfort. Well-maintained vehicles, professional drivers, and ample seating make it ideal for families, friends, or groups seeking economical yet reliable travel to the Shakti Peeth temples."
  },
  {
    "name": "Chauffeur Driven Shakti Peeth Bus",
    "description": "Chauffeur Driven Shakti Peeth Bus provides experienced drivers to handle routes, traffic, and travel logistics, allowing passengers to relax during the journey. This service ensures safe, comfortable, and hassle-free travel for families, groups, and pilgrims visiting the Shakti Peeth temples from Pune."
  },
  {
    "name": "Best Shakti Peeth Tour Bus Pune",
    "description": "Best Shakti Peeth Tour Bus Pune offers top-quality buses and professional service for a superior pilgrimage experience. Spacious interiors, well-maintained vehicles, and skilled drivers ensure a smooth, safe, and comfortable journey for devotees traveling from Pune to the Shakti Peeth temples."
  },
  {
    "name": "Pune Shakti Peeth Travel Bus",
    "description": "Pune Shakti Peeth Travel Bus provides dependable and comfortable transport for individuals and groups traveling to the Shakti Peeth temples. Professional drivers, spacious seating, and luggage-friendly interiors make long-distance travel safe, stress-free, and convenient."
  },
  {
    "name": "Religious Tour Bus Pune",
    "description": "Religious Tour Bus Pune offers buses specifically for spiritual and religious trips, including the Shakti Peeth pilgrimage. Comfortable seating, reliable service, and professional drivers ensure a safe and fulfilling yatra experience for families, friends, and group travelers."
  },
  {
    "name": "Temple Darshan Bus Pune",
    "description": "Temple Darshan Bus Pune provides organized travel for devotees visiting the Shakti Peeth temples. Spacious, comfortable, and safe buses with professional drivers ensure hassle-free transportation, allowing passengers to focus entirely on their spiritual journey."
  },
  {
    "name": "Pilgrimage Bus Hire Pune",
    "description": "Pilgrimage Bus Hire Pune offers specialized buses for religious journeys from Pune to the Shakti Peeth temples. These buses provide comfortable seating, luggage space, and experienced drivers, making long-distance travel safe, convenient, and spiritually enriching."
  },
  {
    "name": "Shakti Peeth Yatra Package Pune",
    "description": "Shakti Peeth Yatra Package Pune combines travel, comfort, and convenience for devotees undertaking the Shakti Peeth pilgrimage. Well-maintained buses, professional chauffeurs, and flexible booking options make it ideal for families, friends, and group tours seeking a seamless yatra experience."
  },
  {
    "name": "Maharashtra Temple Tour Bus",
    "description": "Maharashtra Temple Tour Bus provides comprehensive bus services for visiting multiple temples, including the Shakti Peeth, from Pune. Comfortable and spacious buses with skilled drivers ensure safe, organized, and enjoyable travel for families, groups, and religious tourists."
  }
],
"tableData": [
  ["Sade Teen Shakti Peeth Tour From Pune by Bus Package", "Shakti Peeth Yatra Bus Pune"],
  ["AC Bus Shakti Peeth Tour", "Luxury Bus Shakti Peeth Yatra"],
  ["Family Shakti Peeth Bus Pune", "Group Travel Shakti Peeth Bus"],
  ["Affordable Shakti Peeth Bus Package", "Chauffeur Driven Shakti Peeth Bus"],
  ["Best Shakti Peeth Tour Bus Pune", "Pune Shakti Peeth Travel Bus"],
  ["Religious Tour Bus Pune", "Temple Darshan Bus Pune"],
  ["Pilgrimage Bus Hire Pune", "Shakti Peeth Yatra Package Pune"],
  ["Maharashtra Temple Tour Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Sade Teen Shakti Peeth Tour From Pune by Bus Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and well-organized bus tour packages from Pune to Sade Teen Shakti Peeth, perfect for religious tours, group trips, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses with ample seating and luggage space for a smooth and enjoyable pilgrimage tour."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune city roads and routes to Sade Teen Shakti Peeth, ensuring safe, punctual, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Sade Teen Shakti Peeth bus tour packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and itinerary updates."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages",
    "WhyChoosedescription": "Choose from one-day, multi-day, or customized bus tour packages tailored to your group’s preferences and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Sade Teen Shakti Peeth bus tours from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Sade Teen Shakti Peeth bus tour packages from Pune?',
    answer: 'Yes, Sanavi Travels provides comfortable and well-organized bus tour packages for Sade Teen Shakti Peeth from Pune.'
  },
  {
    question: 'How can I book a Sade Teen Shakti Peeth tour by bus with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the tour?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for group travel and spiritual tours.'
  },
  {
    question: 'Are drivers included in the bus tour package?',
    answer: 'Yes, all tour packages include experienced and professional drivers familiar with the Pune to Sade Teen Shakti Peeth routes.'
  },
  {
    question: 'Is the bus tour service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Sade Teen Shakti Peeth bus tour package?',
    answer: 'Absolutely. Sanavi Travels offers customized tour packages according to your group’s preferences.'
  },
  {
    question: 'What payment options are available for the bus tour?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Sade Teen Shakti Peeth tour.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'Our Sade Teen Shakti Peeth tour from Pune with Sanavi Travels was amazing. Comfortable bus, professional driver, and well-planned itinerary.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha More',
    feedback: 'Excellent experience! Clean bus, on-time pickup, and smooth journey made our spiritual tour memorable. Highly recommend Sanavi Travels.',
    rating: 5
  }
];






































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sade Teen Shakti Peeth Tour From Pune by Bus Package - Sanavi Travels",
  "description": "Book Sade Teen Shakti Peeth tour from Pune by bus with Sanavi Travels. AC and luxury buses for Shakti Peeth yatra, religious tours, temple darshan, family pilgrimages, and group travel with safe and comfortable chauffeur-driven services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Sade Teen Shakti Peeth Tour From Pune by Bus Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses for Sade Teen Shakti Peeth tour from Pune with Sanavi Travels. Ideal for Shakti Peeth yatra, temple darshan, family pilgrimages, and group religious tours across Maharashtra."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sadeteenshaktipeethtourfrom;